import { type InternalTreeMapNode } from '../types/internal.js';

export const isBelowThreshold = (
  node: InternalTreeMapNode,
  areaPerValue: number,
  threshold: number,
) => {
  const isBelowThreshold = node.value * areaPerValue < threshold;

  return isBelowThreshold;
};
